import { Input } from '@pickleballinc/ui/components/ui/input';
import clsx from 'clsx';
import { forwardRef } from 'react';

interface DecoratedInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	disabled?: boolean;
	hasError?: boolean;
	hint?: string;
	label?: string;
	PrefixIcon?: () => React.ReactNode;
	SuffixIcon?: () => React.ReactNode;
	withDivider?: boolean;
	length?: number; // Add new length prop
}

export const DecoratedInput = forwardRef<HTMLInputElement, DecoratedInputProps>(({ length, maxLength, SuffixIcon, ...props }, ref) => {
	// If length prop exists and maxLength exists but no SuffixIcon, create automatic counter
	const AutoSuffixIcon =
		length !== undefined && maxLength && !SuffixIcon
			? () => (
					<div className="text-xs text-gray-500 absolute right-3 top-1/2 -translate-y-1/2">
						{length}/{maxLength}
					</div>
				)
			: SuffixIcon;

	return (
		<div className="flex flex-col gap-1">
			{props.label ? <p className="text-sm">{props.label}</p> : null}
			<div className="relative w-full">
				<Input
					className={clsx('w-full border border-gray-300 bg-white focus-visible:ring-0', {
						'pl-8': Boolean(props.PrefixIcon)
					})}
					ref={ref}
					maxLength={maxLength}
					placeholder={props.placeholder}
					onChange={props.onChange}
					value={props.value}
				/>
				{props.PrefixIcon ? <props.PrefixIcon /> : null}
				{AutoSuffixIcon ? <AutoSuffixIcon /> : null}
			</div>
		</div>
	);
});
